import { Component, inject } from '@angular/core';
import { HeaderModeService } from '../../header-mode/header-mode.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    imports: [RouterLink, NgTemplateOutlet],
})
export class FooterComponent {
    protected headerMode = toSignal(inject(HeaderModeService).headerMode$);
}
